var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-item",class:_vm.getClasses},[_c('div',{staticClass:"header-item__icon"},[_vm._t("default")],2),_c('div',{staticClass:"header-item__text"},[_vm._t("label",function(){return [_c('span',{staticClass:"header-item__label"},[_vm._v(_vm._s(_vm.label))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }